module.exports = __webpack_public_path__ + "static/media/pacRoyale-lobby.785d675a.png";